import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store.js';

Vue.use(Router);

import DashboardRoutes from './modules/dashboard/dashboard.routes';
import MyConsultantRoutes from './modules/myconsultant/myconsultant.routes';
import OpenboxRoutes from './modules/openbox/openbox.routes';
import AdminRoutes from './modules/admin/admin.routes';
import ProfileRoutes from './modules/profile/profile.routes';
import AuthRoutes from './modules/auth/auth.routes';
import OpendataRoutes from './modules/opendata/opendata.routes';
import NotificatiosnRoutes from './modules/notifications/notifications.routes';
import LaboralRoutes from './modules/laboral/laboral.routes';
import ClubRebeldeRoutes from './modules/clubrebelde/clubrebelde.routes';
import OpenBillingRoutes from './modules/openbilling/openbilling.routes';
let router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login,
    //   meta: {
    //     guestOnly: true
    //   },
    // },
    ...AuthRoutes,
    ...DashboardRoutes,
    ...MyConsultantRoutes,
    ...OpenboxRoutes,
    ...AdminRoutes,
    ...ProfileRoutes,
    ...OpendataRoutes,
    ...ClubRebeldeRoutes,
    ...NotificatiosnRoutes,
    ...LaboralRoutes,
    ...OpenBillingRoutes,
  ],
});

function checkIfIsAdminRoute(elementRoute) {
  if (
    !(
      elementRoute.hasOwnProperty('meta') &&
      elementRoute.meta.hasOwnProperty('admin') &&
      elementRoute.meta.admin
    )
  ) {
    return false;
  }

  return true;
}

function userHasPermissions(elementRoute) {
  const userRoleNames = store.getters.userRoleNames;
  if (
    elementRoute.hasOwnProperty('meta') &&
    elementRoute.meta.hasOwnProperty('allowedRoles') &&
    Array.isArray(elementRoute.meta.allowedRoles)
  ) {
    for (let i = 0; i < elementRoute.meta.allowedRoles.length; i++) {
      const role = elementRoute.meta.allowedRoles[i];
      if (userRoleNames.includes(role) || role === 'all') {
        return true;
      }
    }
  } else {
    if (localStorage.getItem('token')) {
      return true;
    }
  }
  return false;
}

function userHasActiveModule(elementRoute) {
  let active = true;

  if (elementRoute.hasOwnProperty('meta') && elementRoute['meta'].hasOwnProperty('module')) {
    active =
      store.getters['customerModules'] &&
      store.getters['customerModules'][elementRoute.meta.module];
  }

  return active;
}

function getDefaultRouteForAuthUser() {
  // console.log('getDefaultRouteForUser');
  const userRoleNames = store.getters.userRoleNames;
  // console.log(userRoleNames);
  if (userRoleNames) {
    const dashboardRoles = ['consultant', 'admin', 'superadmin', 'pyme', 'autonomous', 'employees'];
    const dashboardUser = userRoleNames.some(r => dashboardRoles.includes(r));
    if (dashboardUser) {
      // console.log('User is a dashboard user');

      return '/dashboard';
    }

    if (userRoleNames.includes('lopd')) {
      // console.log('User is a lopd user');

      return '/opendata';
    }
  }
  // console.log('User is a User profile user');

  // store.dispatch('logout');
  return '/user';
}

router.beforeEach((to, from, next) => {
  if (checkIfIsAdminRoute(to) && !store.getters.userIsAdmin) {
    const routePath = getDefaultRouteForAuthUser();
    next(routePath);
  }

  next();
});

// router.beforeEach((to, from, next) => {

//   if (!localStorage.getItem("token")) {

//     next('/login');

//   }

//   next();

// });

router.beforeEach((to, from, next) => {
  if (!store.getters.userRoleNames.length && localStorage.getItem('token')) {
    store.dispatch('logout').then(() => {
      // console.log('logout from routes res:', res);
      next('/login');
    });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (!!localStorage.getItem('token') && to.matched.some(record => record.meta.guestOnly)) {
    const routePath = getDefaultRouteForAuthUser();
    next(routePath);
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (
    !!localStorage.getItem('token') &&
    to.matched.some(record => record.meta.requiresAuth) &&
    (!userHasPermissions(to) || !userHasActiveModule(to))
  ) {
    const routePath = getDefaultRouteForAuthUser();
    next(routePath);
  }
  next();
});

export default router;
